import { Task } from 'redux-saga'
import { call, cancel, fork, put, take } from 'redux-saga/effects'
import getLesson from 'api/lessons/Get'
import * as fromActions from '../../actions/lessons.action'

async function getCourseLesson(lessonId: number) {
  return await getLesson(lessonId)
}

export function* getLessonEffectSaga(action: any) {
  try {
    const data = yield call(getCourseLesson, action.payload)
    yield put(fromActions.Actions.lessonsGetLessonSuccess(data))
  } catch (error) {
    console.log('error: ', error)
    yield put(fromActions.Actions.lessonsLoadFailure())
  }
}

export function* getLmsLessonWatcherSaga() {
  let lastTask: Task | undefined
  let lastLessonId: number | undefined
  while (true) {
    const action = yield take(fromActions.LESSONS_GET_LESSON)
    // Navigation and LessonCard both request the lesson being opened; one request is enough
    if (lastTask?.isRunning() && action.payload === lastLessonId) continue
    // A different lesson wins, e.g. going back after a refused advance while the next lesson is still loading
    if (lastTask?.isRunning()) yield cancel(lastTask)
    lastLessonId = action.payload
    lastTask = yield fork(getLessonEffectSaga, action)
  }
}
